import { submitPostForm } from '@/utils/submitPostForm';
import { useCsrfToken } from 'ap-openapi';
import { useCallback } from 'react';

export const useCopyInvoiceReportService = () => {
  const csrfToken = useCsrfToken();

  const copyAsync = useCallback(
    async (copyPath: string) => {
      if (!copyPath || !csrfToken) return;

      /*
       * use submitPostForm to avoid double load when backend returns 302.
       * With fetch + redirect: 'follow', the browser would: (1) fetch follows redirect = 1st GET, this will not trigger set sessionStorage for the flash message.
       * (2) window.location.href = 2nd GET. Form submit lets the browser handle redirect natively = 1 GET only.
       */
      submitPostForm(copyPath, csrfToken);
    },
    [csrfToken]
  );

  return { copyAsync };
};
